// extracted by mini-css-extract-plugin
module.exports = {"dg200Banner":"Banner_dg200Banner__Pcu65"};